<template>
    <div id="tab-change-button">
        <div class="button-container">
            <div class="button back" @click="prevPage" v-if="prevButton">
                <md-icon>arrow_back</md-icon>
            </div>
            <div class="button next" @click="nextPage" v-if="nextButton">
                <md-icon>arrow_forward</md-icon>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "TabChangeButton",
    props: {
        nextButton: {
            type: Boolean,
            default: true,
        },
        prevButton: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        nextPage() {
            this.$emit("nextPage");
        },
        prevPage() {
            this.$emit("prevPage");
        },
    },
};
</script>
<style lang="scss">
#tab-change-button {
    $base-color: #ec4b1d;
    $text-color: #171725;

    .button-container {
        display: flex;
        align-items: center;

        .button {
            background-color: $base-color;
            padding: 8px;
            cursor: pointer;
            user-select: none;
            border-radius: 9999px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 10px 5px;

            i {
                width: 100%;
                height: 100%;
                color: white;
                font-size: 25px !important;
            }
        }
    }
}
</style>
